import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { Menu } from '@app/shared/models';
import { MenuService } from '@app/shared/services';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css'],
})
export class LocationComponent implements OnInit, OnDestroy {
  menus: Menu[];
  locationSubscription: Subscription;

  isLoading = false;

  routeArray: RoutePart[] = [];
  menid: number;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private menuService: MenuService
  ) {
    this.locationSubscription = this.router.events.subscribe((event) => {
      if (event instanceof ActivationEnd) {
        this.getMenus();
      }
    });
  }

  ngOnInit(): void {
    this.getMenus();
  }

  ngOnDestroy(): void {
    this.locationSubscription.unsubscribe();
  }

  translateMenu(menuToTranslate: string): RoutePart[] {
    const translatedMenu: RoutePart[] = [];

    this.menus.forEach((groupMenu) => {
      if (groupMenu.menu1) {
        groupMenu.menu1.forEach((submenu) => {
          if (submenu.menu1) {
            submenu.menu1.forEach((menu) => {
              if (menu.mencontroller.toLowerCase() === menuToTranslate) {
                translatedMenu.push({
                  translated: this.translateService.instant(groupMenu.mendtbshort) ?? groupMenu.mendtbshort,
                  route: groupMenu.menname
                });
                translatedMenu.push({
                  translated: this.translateService.instant(submenu.mendtbshort) ?? submenu.mendtbshort,
                });
                translatedMenu.push({
                  translated: this.translateService.instant(menu.mendtbshort) ?? menu.mendtbshort,
                  route: groupMenu.menname + "/" + menu.menname
                });
                this.menid = menu.menid;
              }
            });
          }
        });
      }
    });

    return translatedMenu;
  }

  private getMenus() {
    if (!this.isLoading) {
      this.isLoading = true;

      this.menuService.getChildMenu(null).subscribe((r) => {
        this.menus = r;

        this.setText();

        this.isLoading = false;
      });
    }
  }

  private setText() {
    let routeSplit = this.router.url.split('/').slice(1);
    this.routeArray = [];
    if (routeSplit.length >= 2) {
      routeSplit[routeSplit.length - 1] = routeSplit[routeSplit.length - 1].split('?')[0];
      this.routeArray = this.translateMenu(routeSplit[1]);
    }
  }

}

interface RoutePart {
  translated: string;
  route?: string;
}
